import { useRef, useState } from 'react';
import { recordCashReceipt, recordPosReceipt, reportBankTransfer, registerCheque, uploadPaymentEvidence } from '../models/paymentsV2Model';
import { decimal } from '../utilities/paymentPresentation';
import { usePaymentCommand } from './usePaymentCommand';
export function useRecordPayment(projection, reload) {
  const [files, setFiles] = useState([]);
  const uploads = useRef(null);
  const command = usePaymentCommand(`receipt-${projection.query_pk}`, () => reload({ silent: true }));
  const submit = async values => {
    await command.submit(async payload => {
      if (!uploads.current) uploads.current = await Promise.all(files.map(uploadPaymentEvidence));
      const full = { ...payload, evidence_upload_ids: uploads.current.map(row => row.id) };
      if (values.method === 'cheque') { if (values.state === 'expected') delete full.evidence_upload_ids; return registerCheque(values.state, full); }
      return ({ cash: recordCashReceipt, pos: recordPosReceipt, bank: reportBankTransfer })[values.method](full);
    }, {
      total_amount: decimal(values.amount), allocations: [{ invoice_id: projection.invoice.id, amount: decimal(values.amount) }],
      ...(values.arrangement_id ? { arrangement_applications: [{ settlement_arrangement_id: values.arrangement_id, amount: decimal(values.amount) }] } : {}),
      ...(values.method === 'cash' ? { collected_at: values.occurred_at.toISOString(), collection_location: { type: values.location } } : values.method === 'pos' ? { collected_at: values.occurred_at.toISOString() } : values.method === 'bank' ? { transferred_at: values.occurred_at.toISOString(), bank_reference: values.reference?.trim() || null } : { cheque_number: values.cheque_number, bank_name: values.bank_name, cheque_date: values.cheque_date.format('YYYY-MM-DD') }),
      ...(values.method !== 'cheque' ? { notes: values.notes || null } : {}),
    });
  };
  return { ...command, files, setFiles, submit };
}
